<template>
  <CardModule title="Vendas" class="mt-6">
    <v-row>
      <v-col>
        <v-checkbox
          v-model="$marketplace.cadastro.assertiva_cpf"
          label="Integração Assertiva - Validação CPF"
          active-class="active-class"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          hide-details
        >
        </v-checkbox>
      </v-col>
    </v-row>
  </CardModule>
</template>
<script>
export default {
  name: "Sales",
  data() {
    return {};
  },
  components: {
    CardModule: () => import("@/components/cards/CardModule.vue"),
  },
};
</script>
